export default __webpack_public_path__ + "locales/zh-CN/ChangeUserTypeDialog.json?hash=abb6708989f76141082c30c93e0d9e9f";